/*********************** Custom JS for Boost AI Search & Discovery  ************************/

const customize = {
  updateMetaInfo: (componentRegistry) => {
    componentRegistry.useComponentPlugin("ProductItem", {
      name: "Modify Product Info",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          let data = element.getParams().props.product;
          let productItem = document.querySelector(
            '[data-product-id="' + data.id + '"]'
          );

          if (window.location.pathname == "/collections/all") {
            if (
              window.location.search.indexOf("pf_mlt_te_chang") > 0 ||
              window.location.search.indexOf("pf_mlt_sutairu") > 0
            ) {
              $(".shopify-section--collection-banner").hide();
            } else {
              $(".shopify-section--collection-banner").show();
            }
          } else {
            $(".shopify-section--collection-banner").show();
          }

          setTimeout(function () {
            $(
              ".template-collection .boost-sd__filter-option-item-multilevel-collections-firstlevel .boost-sd__filter-option-item-button"
            ).click(function () {
              //$('html,body').animate({scrollTop: 0},'slow');
              let href = $(this).attr("href");
              window.location.href = href;
            });
          }, 500);

          const customBadgesData = data.tags.filter(function (e) {
            return e.indexOf("label__") !== -1;
          });

          let regex = /^[a-zA-Z\s0-9,&\/\-.]+$/;

          let metaHtml = "";
          if (typeof customBadgesData[0] !== "undefined") {
            const tagValue = customBadgesData;
            metaHtml += `<ul class="c-product__relatedTags">`;
            for (let i = 0; i < tagValue.length; i++) {
              let value = tagValue[i].split("__");
              // let link = value[1];
              let tag = value[1];
              if (tag != "undefined") {
                tagEncode = encodeURIComponent(tagValue[i]);
                if (regex.test(tag)) {
                  metaHtml += `<li class="c-product__relatedTag"><a href="/collections/all?pf_mlt_sutairu=${tagEncode}" class="c-product__relatedTag--link">#${tag}</a></li>`;
                } else {
                  metaHtml += `<li class="c-product__relatedTag"><a href="/collections/all?pf_mlt_te_chang=${tagEncode}" class="c-product__relatedTag--link">#${tag}</a></li>`;
                }
              }
            }
            metaHtml += `</ul>`;
            if (productItem.querySelector(".c-product__relatedTags") == null) {
              productItem
                .querySelector(".boost-sd__product-info")
                .insertAdjacentHTML("afterend", metaHtml);
            }

            // Display Meta field
            // const metaData = data.metafields.filter(function(e) {
            //   return e.namespace == 'custom' && e.key == 'relation_tag';
            // })

            // let metaHtml = '';
            // if (typeof metaData[0] !== 'undefined') {
            //   const metaValue = metaData[0]['value'].split(',');
            //   metaHtml += `<ul class="c-product__relatedTags">`
            //     for(let i = 0; i < metaValue.length; i++) {
            //       let value = metaValue[i].split("__");
            //       let tag = value[0];
            //       let link = value[1];

            //       if (link != undefined) {
            //         metaHtml += `<li class="c-product__relatedTag"><a href="/collections/${link}" class="c-product__relatedTag--link">#${tag}</a></li>`;
            //       }
            //     }
            //   metaHtml += `</ul>`;

            //   if (productItem.querySelector('.c-product__relatedTags') == null) {
            //     productItem.querySelector('.boost-sd__product-info').insertAdjacentHTML('afterend', metaHtml);
            //   }
          }

          const metaPriceChange = data.metafields.filter(function (e) {
            return e.namespace == "custom" && e.key == "price_change";
          });
          if (typeof metaPriceChange[0] !== "undefined") {
            if (metaPriceChange[0].value == "true") {
              productItem
                .querySelector(".boost-sd__format-currency span")
                .classList.add("c-price-change");
            }
          }

          if (data.price_max == 0) {
            productItem.querySelector(
              ".boost-sd__product-price-wrapper"
            ).innerHTML = '<span class="price-none">-</span>';
          }
        },
      }),
    });
    componentRegistry.useComponentPlugin("PaginationButton", {
      name: "Modify Pagination Button",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          function click() {
            const targetSection = $("#collection-banner");

            // if ($(window).width() < 767) {
            //   $("html, body").animate(
            //     { scrollTop: targetSection.offset().top - 60 },
            //     1000
            //   );
            // } else if ($(window).width() < 1200) {
            //   $("html, body").animate(
            //     { scrollTop: targetSection.offset().top },
            //     1000
            //   );
            // } else {
              $("html, body").animate(
                { scrollTop: targetSection.offset().top },
                1000
              );
            // }
          }
          $(".boost-sd__pagination button").unbind("click");
          $(".boost-sd__pagination button").on("click", click);
        },
      }),
    });
  },
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  customize.updateMetaInfo,
]);
window.boostSDAppConfig = window.boostSDAppConfig || {};
window.boostSDAppConfig.generalSettings = window.boostSDAppConfig.generalSettings || {};
window.boostSDAppConfig.generalSettings.productPerPage = 90; // 新しい設定

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat((registry) => {
    registry.useModulePlugin('FilterAPI', {
        name: 'Fix collection all returning incorrect data ',
        apply(builder) {
            builder.on('beforeMethodCall', 'get', (payload) => {
                if (boostSDAppConfig?.generalSettings?.collection_handle == 'all') {
                    payload.args[0].collection_scope = boostSDAppConfig?.generalSettings?.collection_id;
                }
            });
        },
    });
});